import _extends from "@babel/runtime/helpers/extends";
import { createTrendingItemsComponent } from '@algolia/recommend-vdom';
import React, { createElement, Fragment } from 'react';
import { useTrendingItems } from './useTrendingItems';
const UncontrolledTrendingItems = createTrendingItemsComponent({
  createElement,
  Fragment
});
export function TrendingItems(props) {
  const {
    recommendations,
    status
  } = useTrendingItems(props);
  return /*#__PURE__*/React.createElement(UncontrolledTrendingItems, _extends({}, props, {
    items: recommendations,
    status: status
  }));
}